import get from 'lodash/get';
import set from 'lodash/set';
import isEqual from 'lodash/isEqual';
import isUndefined from 'lodash/isUndefined';
import store from '@/store/store';
import entiteCommercialeGenerer from '@/services/entiteCommerciale/genererEntiteCommerciale';
import { SENS_VENTE } from '@/configuration/devisConf';
import { PARAMETRES_KEYS } from '@/store/modules/parametrage-mutation-type';

const PROPERTIES = [
  'produitFace.azimut',
  'produitFace.format',
  'produitFace.formatId',
  'produitFace.materielType',
  'referenceConfrere',
  'produitFace.adresse',
  'produitFace.disposition',
];

function getProduitFace() {
  return {
    codePanneau: null,
    format: null,
    materielType: null,
    azimut: null,
    adresse: null,
    support: null,
    localisation: null,
    enAllantVers: null,
    enVenantDe: null,
    angleDeVision: null,
    eclairee: false,
    produitParDefautId: null,
    affimetrie: {},
    restrictionsAffichage: null,
    proposableReseau: true,
    proposableLc: true,
    disposition: null,
  };
}

export function getProduitFaceBase() {
  return {
    reference: null,
    libelle: '',
    liaisonsTarif: [],
    supportCommercialId: null,
    supportCommercial: null,
    entiteCommerciale: entiteCommercialeGenerer(),
    schemaComptableId: null,
    schemaComptable: null,
    produitFace: getProduitFace(),
    tiersId: null,
    logisticable: true,
    agenceId: null,
    categorieGroupeProduitDeductibleId: null,
    sens: SENS_VENTE,
  };
}

export function majProduitFaceByPanneau(produit, panneau, supportCommercial, agenceId) {
  produit.guid = panneau.guid;
  produit.agenceId = agenceId || null;
  produit.tiers = { nomCommercial: panneau.regie, id: panneau.regieId };
  produit.srcImg = panneau.srcImg;
  produit.urlLogo = panneau.urlLogo;
  produit.tiersId = panneau.regieId;
  produit.referenceConfrere = panneau.referenceConfrere || null;
  produit.produitFace.format = panneau.format;
  produit.produitFace.formatId = panneau.formatId;
  produit.produitFace.azimut = panneau.azimut;
  produit.produitFace.adresse = panneau.adresse;
  produit.produitFace.materielType = panneau.materiel;
  produit.produitFace.disposition = panneau.disposition;
  produit.panneauActif = panneau.actif;
  const supportCommericalVal = supportCommercial ? supportCommercial : produit.supportCommercial;
  produit.supportCommercial = supportCommericalVal;
  produit.supportCommercialId = supportCommericalVal.id;
  if (agenceId) {
    produit.agenceId = agenceId;
  }
  return produit;
}

export function majProduitFaceByProduit(produit, produitToUpdate) {
  PROPERTIES.forEach((path) => {
    const valueB = get(produitToUpdate, path);
    const valueA = get(produit, path);

    if (isUndefined(valueB)) return;

    if (!isEqual(valueA, valueB)) {
      set(produit, path, valueB);
    }
  });

  return produit;
}

export function majFormatIdProduit(produit) {
  if (produit.produitFace.formatId || !produit.produitFace.format) return;
  const formats = store.getters['parametrage/parametre'](PARAMETRES_KEYS.materielFormat);
  const format = formats.find(f => f.libelle.toLowerCase().includes(produit.produitFace.format.toLowerCase()));
  if (!format) return;
  produit.produitFace.formatId = format.id;
}
